import React from 'react';
import PropTypes from 'prop-types';
import chunk from 'lodash.chunk';
import WordRow from './WordRow';
import { PROBE_DETAIL } from '../../../../constants/shared/CommonConstants';
import './NwfProbeDetails.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const NwfProbeDetails = props => {
    const { content, result } = props;
    const mergedContentWithResults = content.items.map(item => ({
        ...item,
        ...result.itemLevelDetails.word_events.find(
            wordEvent => wordEvent.item_idx === item.item_idx,
        ),
    }));
    return (
        <div className="container">
            {chunk(mergedContentWithResults, PROBE_DETAIL.WORDS_IN_ROW).map((wordItems, index) => (
                <WordRow key={generateReactKey(index)} wordItems={wordItems} />
            ))}
        </div>
    );
};

NwfProbeDetails.propTypes = {
    content: PropTypes.object.isRequired,
    result: PropTypes.object.isRequired,
};

export default NwfProbeDetails;
